<script context="module" lang="ts">
    export interface PrestationContactProps {
		id: string;
		title: string;
		text: string;
    }
    
</script>

<script lang="ts">

	import { storeDomain } from "../scripts/store";
	import { iOS } from "../scripts/commons";
	
	export let props: PrestationContactProps;

</script>

<style lang="scss">

    .prestationContact {
        display: grid;
		grid-template-areas: 
			"habillage habillage vide"
			"texte texte texte"
			"map map map"
			"credits credits credits";
		grid-template-columns: 60% 20% 20%;
		grid-template-rows: auto auto auto 30px;
        width: 100%;
		&__habillage {
			grid-area: habillage;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			&__slash {
				width: 66px;
				height: 40px;
			}
			&__line {
				margin-right: -30px;
				margin-left: -$contener-marge-small;
				width: 100%;
				&__services {
					border-top: 1px solid $color-bleu-clair-instit;
				}
				&__amenagements {
					border-top: 1px solid $color-orange-dde;
				}
			}
		}
		&__text {
			grid-area: texte;
			&__facebook {
				margin: 30px 0 0 0;
				&__a {
					text-decoration: none;
					color: $color_white;
				}
				&__img {
					height: 16px;
					margin: 0 15px 0 0;
				}
			}
		}
		&__map {
			grid-area: map;
			margin: 15px 0 0 0;
			width: 100%;
			height: 400px;
			mix-blend-mode: luminosity;
		}
		&__mapios {
			grid-area: map;
			margin: 15px 0 0 0;
			width: 100%;
			&__img {
				width: 100%;
			}
		}
		&__enbas {
			grid-area: credits;
			display: flex;
			flex-direction: row;
			padding: 0 0 30px 0;
		}
		&__credits {
			display: flex;
			flex-direction: column;
			font-family: 'Montserrat', sans-serif;
			font-size: 10px;
			font-weight: 400;
			&__link {
				text-decoration: none;
				color: $color-white;
			}
			&__slash {
				font-weight: bold;
				&__services {
					color: $color-bleu-clair-instit;
				}
				&__amenagements {
					color: $color-orange-dde;
				}
			}
		}
	}

	@include large {
        .prestationContact {
			grid-template-areas: 
				"habillage plus"
				"texte map"
				"credits credits";
			grid-template-columns: 33% 1fr;
			grid-template-rows: 40px 1fr 1fr;
			column-gap: 30px;
			row-gap: 30px;
			&__habillage {
				&__line {
					margin-left: -$contener-marge-large;
					width: calc($contener-marge-large-pourcent / 2);
				}
			}
			&__map {
				margin: 0;
				height: 500px;
			}
			&__enbas {
				flex-direction: column;
				justify-content: flex-end;
			}
			&__credits {
				z-index: 200;
				flex-direction: row;
				width: 50%;
			}
        }
	}

	@include extra-large {
        .prestationContact {
			&__habillage {
				&__line {
					margin-left: -$contener-marge-large;
					width: calc($contener-marge-large-pourcent / 2);
					&__ext {
						position: absolute;
						margin-left: -1000px;
						width: 1000px;
						&__services {
							border-bottom: 1px solid $color-bleu-clair-instit;
						}
						&__amenagements {
							border-bottom: 1px solid $color-orange-dde;
						}
					}
				}
			}
        }
	}

</style>

<div class="prestationContact">
	<div class="prestationContact__habillage">
		<div class="prestationContact__habillage__line" class:prestationContact__habillage__line__services={$storeDomain == "services"} class:prestationContact__habillage__line__amenagements={$storeDomain == "amenagements"}>&nbsp;</div>
		<div class="prestationContact__habillage__line__ext" class:prestationContact__habillage__line__ext__services={$storeDomain == "services"}  class:prestationContact__habillage__line__ext__amenagements={$storeDomain == "amenagements"}></div>
		{#if ($storeDomain == "services")}
			<img class="prestationContact__habillage__slash" src="../images/slash-services.png" alt="slash services">
		{:else}
			<img class="prestationContact__habillage__slash" src="../images/slash-amenagements.png" alt="slash amenagements">
		{/if}
	</div>
	<div class="prestationContact__text">
		<div class="font-txt-courant-bold">{props.title}</div>
		<div>
			{@html props.text}
		</div>
		{#if ($storeDomain == "amenagements")}
		<div class="prestationContact__text__facebook">
			<a class="prestationContact__text__facebook__a" href="https://www.facebook.com/profile.php?id=100083182999289" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/facebook-amenagements.png" alt="facebook">facebook
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.instagram.com/attal_services/" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/instagram-amenagements.png" alt="instagram">instagram
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.youtube.com/channel/UCxgA7zdRFJAkmehErPG9ilA" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/youtube-amenagements.png" alt="youtube">youtube
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.linkedin.com/company/attal-services" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/linkedin-amenagements.png" alt="linkedin">linkedin
			</a>	
		</div>
		{:else}
		<div class="prestationContact__text__facebook">
			<a class="prestationContact__text__facebook__a" href="https://www.facebook.com/profile.php?id=100083182999289" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/facebook-services.png" alt="facebook">facebook
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.instagram.com/attal_services/" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/instagram-services.png" alt="instagram">instagram
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.youtube.com/channel/UCxgA7zdRFJAkmehErPG9ilA" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/youtube-services.png" alt="youtube">youtube
			</a><br>
			<a class="prestationContact__text__facebook__a" href="https://www.linkedin.com/company/attal-services" target="_blank" rel="noreferrer">
				<img class="prestationContact__text__facebook__img" src="../images/linkedin-services.png" alt="linkedin">linkedin
			</a>	
		</div>
		{/if}
	</div>
	{#if iOS()}
	<div class="prestationContact__mapios">
		<a href="https://www.google.com/maps/place/208+Saint-Jacques,+44850+Saint-Mars-du-D%C3%A9sert/@47.338618,-1.474716,15z/data=!4m5!3m4!1s0x4805fa7251c6dbdb:0xa5bec69be79b0137!8m2!3d47.3386182!4d-1.4747163?hl=fr" alt="google maps Attal" target="_blank" rel="noreferrer">
			{#if ($storeDomain == "amenagements")}
				<img class="prestationContact__mapios__img" src="../images/amenagements/map-amenagements.png" alt="google maps Attal" title="google maps Attal">
			{/if}
			{#if ($storeDomain == "services")}
				<img class="prestationContact__mapios__img" src="../images/services/map-services.png" alt="google maps Attal" title="google maps Attal">
			{/if}
		</a>
	</div>		
	{:else}
	<div class="prestationContact__map">
		<iframe title="google maps attal" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5407.586832592643!2d-1.4776667!3d47.3379057!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805fa7251c6dbdb%3A0xa5bec69be79b0137!2s208%20Saint-Jacques%2C%2044850%20Saint-Mars-du-D%C3%A9sert!5e0!3m2!1sfr!2sfr!4v1669133077323!5m2!1sfr!2sfr" width="100%" height="100%" style="border:0;" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
	</div>		
	{/if}
	<div class="prestationContact__enbas">
		<div class="prestationContact__credits">
			<div>&copy;ATTAL 2022&nbsp;</div>
			<div>
				<span class="prestationContact__credits__slash" class:prestationContact__credits__slash__services={$storeDomain == "services"} class:prestationContact__credits__slash__amenagements={$storeDomain == "amenagements"}>/</span>
				&nbsp;Graphisme&nbsp;<a  class="prestationContact__credits__link" href="https://francoisvesvard.fr/" alt="François Vesvard" target="_blank" rel="noreferrer">francoisvesvard.fr</a>&nbsp;	
			</div>
			<div>
				<span class="prestationContact__credits__slash" class:prestationContact__credits__slash__services={$storeDomain == "services"} class:prestationContact__credits__slash__amenagements={$storeDomain == "amenagements"}>/</span>
				&nbsp;Développement&nbsp;web&nbsp;<a  class="prestationContact__credits__link" href="https://www.kortefa.net" alt="körtefa" target="_blank" rel="noreferrer">kortefa.net</a>	
			</div>
		</div>	
	</div>
</div>
